<div class="elevator-detail-page">
  <div class="toolbar">
    <ctrl-btn-back
      i18n-namedFallbackUrl="
        InfoPortal_ElevatorsDetail_BuGoBack_NamedFallbackUrl
      "
      namedFallbackUrl="Facility Overview"

      >

    </ctrl-btn-back>
    @if (uiState && user.internalAccess) {
      <ctrl-btn icon="edit" content="Edit"
        i18n-content="InfoPortal_ElevatorsDetail_BuEdit_Content" (click)="onFacilityUpdateRequest()">
      </ctrl-btn>
    }
    @if (isMonitoringSystemConnectVisible()) {
      <ctrl-btn
        [disabled]="!isMonitoringSystemConnectEnabled()"
        i18n-content="InfoPortal_ElevatorsDetail_BuMonitoringConnect_Content"
        content="Connect"
        i18n-title="InfoPortal_ElevatorsDetail_BuMonitoringConnect_Title"
        title="Connect to a monitoring system"
        icon="link"
        (click)="onMonitoringSystemConnect()"
        >
      </ctrl-btn>
    }
    @if (isMonitoringSystemDisconnectVisible()) {
      <ctrl-btn
        i18n-content="InfoPortal_ElevatorsDetail_BuMonitoringDisconnect_Content"
        content="Disconnect"
        i18n-title="InfoPortal_ElevatorsDetail_BuMonitoringDisconnect_Title"
        title="Disconnect from the monitoring system"
        icon="clear"
        (click)="onMonitoringSystemDisconnect()"
        >
      </ctrl-btn>
    }
    @if (uiState && user.internalAccess) {
      <mat-button-toggle-group
        id="toggleGroupLayout"
        #toggleGroupLayout="matButtonToggleGroup"
        appearance="legacy"
        [(ngModel)]="uiState.layout"
        >
        <mat-button-toggle
          value="layout-grid"
          i18n-title="@@InfoPortal_ElevatorsDetail_BuLayoutGrid_Tooltip"
          title="Arrange cards as tiles"
          >
          <mat-icon>grid_on</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          value="layout-stream"
          i18n-title="@@InfoPortal_ElevatorsDetail_BuLayoutStream_Tooltip"
          title="Arrange cards in a stream"
          >
          <mat-icon>view_day</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }
  </div>
  <div class="widgets-container">
    <div class="widgets-grid" [class]="uiState?.layout || 'layout-grid'">
      <div class="cell-facility">
        <facility-overview [facility]="data" [monitoringStatus]="monitoringStatus"></facility-overview>
      </div>
      @if (user.internalAccess) {
        <div class="cell-notes">
          <app-infoportal-notes-facility-overview
            [facilityNoInternal]="data?.anlageNrIntern"
            (noteFacilityCreated)="onFacilityNotesChanged()"
            (noteFacilityUpdated)="onFacilityNotesChanged()"
            (noteFacilityDeleted)="onFacilityNotesChanged()"
            [showPagination]="true"
            >
          </app-infoportal-notes-facility-overview>
        </div>
      }
      <div class="cell-documents">
        <process-overview facilityID="{{ data?.anlageID }}" [facilityNoInternal]="facilityNoInternal"></process-overview>
      </div>
      @if (user.internalAccess) {
        <div class="cell-history">
          <wartungshistory-component
            [facilityNoInternal]="facilityNoInternal"
          ></wartungshistory-component>
        </div>
      }
    </div>
  </div>
</div>